"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _queryString = _interopRequireDefault(require("query-string")),
    isPublicUrl = function isPublicUrl() {
  var a = _queryString["default"].parse(window.location.search),
      b = a.p;

  return !!b;
},
    _default = isPublicUrl;

exports["default"] = _default;